import uiRouter, { StateProvider } from '@uirouter/angularjs';
import angular from 'angular';
import { ResourcesDetailControllerModule } from './controllers/ResourcesDetailController';

export const ResourcesDetailView = angular
  .module('acme.view.application.resources.detail', [
    uiRouter,
    'ui.bootstrap',
    ResourcesDetailControllerModule,
    'acme.common.controller.resourceAssignment',
  ])
  .config(function config($stateProvider: StateProvider) {
    $stateProvider.state({
      name: 'application.resourcesDetail',
      url: '/resources/detail/:id',
      views: {
        'subview-main': {
          controller: 'ResourcesDetailController',
          // Assumes the view is entirely self contained
          templateUrl: 'views/application/views/resources/detail/detail.tpl.html',
        },
      },
      data: {
        pageTitle: 'Resource Template',
        rule: function (permits) {
          // Allow if state is not in exclusions array
          return permits.indexOf('application.resources.detail') !== -1;
        },
      },
    });
  }).name;
